import React from "react";
import SERVICES from "../../../constants/services";
import ServiceCard from "../../../components/ServiceCard/ServiceCard";
import { SECTIONIDS } from "../../../constants/sectionId";

type Props = {};

const ServicesSection = (props: Props) => {
  return (
    <section
      id={SECTIONIDS.SERVICES}
      className="relative bg-black pb-20 md:pb-0 lg:pb-0 "
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-12 xl:px-6 2xl:px-0">
        <div className="flex flex-wrap items-center gap-6">
          <h2 className="text-7xl font-bold text-white xl:text-8xl">
            Our services
          </h2>
          <span className="h-max rounded-full border border-white/40 px-2 py-1 text-xs tracking-wider text-white">
            03 services
          </span>
        </div>
        <div className="mt-24">
          <div className="">
            <div className="grid gap-12 sm:grid-cols-2 xl:grid-cols-3">
              {SERVICES.map((service, index) => (
                <ServiceCard service={service} index={index + 1} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
